export * from './queries';

export const orderKeys = {
  order: (locale: string, orderId: string) => ['order', locale, orderId],
};
